import { Link } from "react-router-dom";
import RightDocSidebar from "../../components/RightSidebar";

import AddBooking from "../../components/Event Booking Management/AddBooking";
import EventEstimates from "../../components/Event Booking Management/EventEstimates";
import Bookings from "../../components/Event Booking Management/Bookings";
import ReceiptVouchers from "../../components/Event Booking Management/ReceiptVouchers";
import CompleteBookingList from "../../components/Event Booking Management/CompleteBookingList";
import ShiftBookingList from "../../components/Event Booking Management/ShiftBookingList";
import CancelBookingList from "../../components/Event Booking Management/CancelBookingList";
import CustomerList from "../../components/Event Booking Management/CustomerList";
import RefundVouchers from "../../components/Event Booking Management/RefundVouchers";
import EventCalender from "../../components/Event Booking Management/EventCalender";
import DocNavigation from "../../components/DocNavigation";

export default function EventBookingManagment() {
  const groups = [
    {
      title: "1. Event Estimates",
      expandable: false,
      items: [{ id: "event-estimates" }],
    },
    {
      title: "2. Event Bookings",
      expandable: true,
      items: [
        { id: "add-booking", label: "2.1 Add Booking" },
        { id: "bookings", label: "2.2 Bookings" },
        { id: "receipt-vouchers", label: "2.3 Receipt Vouchers" },
        { id: "complete-booking-list", label: "2.4 Complete Booking List" },
        { id: "shift-booking-list", label: "2.5 Shift Booking List" },
        { id: "cancel-booking-list", label: "2.6 Cancel Booking List" },
        { id: "customer-list", label: "2.7 Customer List" },
        { id: "refund-voucher", label: "2.8 Refund Voucher" },
      ],
    },
    {
      title: "3. Event Calendar",
      expandable: false,
      items: [{ id: "event-calendar" }],
    },
  ];

  return (
    <div className="flex gap-12">

      {/* MAIN CONTENT */}
      <div className="flex-1 space-y-16">

        {/* HERO */}
        <section className="bg-white rounded-xl border border-slate-200 p-10">
          <h1 className="text-2xl font-bold mb-4">
            Event Booking Management
          </h1>
          <p className="text-md text-slate-600 max-w-3xl">
            Manage the complete lifecycle of bookings including estimates,
            confirmations, payments, and cancellations.
          </p>
        </section>

        {/* CONTENT SECTIONS */}
        <EventEstimates />
        <AddBooking />
        <Bookings />
        <ReceiptVouchers />
        <CompleteBookingList />
        <ShiftBookingList />
        <CancelBookingList />
        <CustomerList />
        <RefundVouchers />
        <EventCalender />

        {/* NEXT */}
        <section className="border-t pt-8">
          <p className="text-slate-600">
            Next, explore the{" "}
            <Link
              to="/docs/reports"
              className="text-[#C9A24E] font-medium"
            >
              Report Module
            </Link>.
          </p>
        </section>
               {/* NEXT */}
        <DocNavigation
          previous={{
            title: "Dashboard",
            link: "/docs/admin-dashboard"
          }}
          next={{
            title: "Report Module",
            link: "/docs/reports"
          }}
        />
      
      </div>

      {/* RIGHT SIDEBAR — DESKTOP ONLY */}
      
    <RightDocSidebar groups={groups} />

    </div>
  );
}
